import { pxArrayToRem, pxToRem, type StyleRule } from '@archipro-design/aria';

export const BannerActions: StyleRule = () => ({
    display: 'grid',
    gridAutoFlow: 'column',
    columnGap: pxToRem(8),
});

export const Section: StyleRule = () => ({
    padding: pxArrayToRem([0, 50]),
});

export const SectionContent: StyleRule = () => ({
    padding: pxArrayToRem([60, 0]),
});
